<template>
  <span style="text-align:left;">
    <template v-if="modo=='new'||modo=='edit'||modo=='flow'">
      <v-switch
        v-model="intravalue"
        :hint="T(campo.cmp_dica)"
        persistent-hint
        required
        :rules="crud.evalrules(campo)"
      ></v-switch>
    </template>

    <template v-if="modo=='list' || modo=='view' || modo=='viewmode'">
      <span :class="{'text-xs-center':crud.action=='list'}">
        <v-icon color="blue" v-if="value" dark title="ON">toggle_on</v-icon>
        <v-icon color="grey" v-if="!value" dark title="OFF">toggle_off</v-icon>
      </span>
    </template>

    <template v-if="modo=='filtro'">
      <v-switch height="20" class="ma-0 pa-1" hide-details v-model="intravalue"></v-switch>
    </template>
  </span>
</template>
    

<script>
try{
  var _baseComponent = require("@/lib/componente/_base.vue").default;
}catch(err){
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
export default {
  extends: _baseComponent,
  data() {
    return {
      intravalue: this.preLoad(this.value),
    };
  },
  computed: {},
  methods: {
    preLoad(myval) {
      if (myval == undefined || myval == null || myval == 0 || myval == false)
        return false;
      if (myval == 1 || myval == true) return true;
      return myval;
    },
    preUpdate(myval) {
      return myval;
    },
  },
  watch: {
    intravalue(val) {
      this.$emit("input", this.preUpdate(val));
    },
  },
};
</script>

<style scoped>
</style>

    